import { createAction, props } from '@ngrx/store';
import { SubmittedPensionPaymentScheduleModel } from 'src/app/model/pension-payment-schedule.model';

export const ResetFormAction = createAction('[Pension Change Payment Schedule Requests] reset data');

export const GetChangePaymentScheduleRequestsRequestAction = createAction('[Pension Change Payment Schedule Requests] get submissions', props<{accountId:number}>())
export const GetChangePaymentScheduleRequestsResponseAction = createAction('[Pension Change Payment Schedule Requests] save submissions', props<{requests:SubmittedPensionPaymentScheduleModel[]}>())